import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import TableUtils from '../../../utils/TableUtils';
import TablePlain from '../../../components/table-plain/TablePlain'
import {map } from 'lodash';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import lstrings from '../../../utils/LStrings';

class TableDeudoresCentro extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.processInfo(props.data.datos);
    }
    processInfo = (info) => {
        return {
            chequesrechazados: info,
        }
    }

    render() {
        return (
            <div>
                <p>
                    {lstrings.verazObsDescription}
                </p>
                <TablePlain
                    columns={[
                        lstrings.fecha_deuda,
                        lstrings.monto,
                        lstrings.informador,
                        lstrings.origenDeuda,
                        lstrings.estadoDeuda,
                        lstrings.tipoDeudor,
                    ]}
                    rows={map(this.state.chequesrechazados, (item, ix) =>
                        <tr key={ix}>
                            <td>{TableUtils.dateFormat(item.fechaDeAtraso)}</td>
                            <td>{TableUtils.ARSFormat(item.deudaTotal)}</td>
                            <td>{item.nombreInstituto}</td>
                            <td>{item.nombreSocio}</td>
                            <td>{item.codDeEstado}</td>
                            <td>{item.tipoDeudor}</td>
                        </tr>)
                    }
                />
            </div>
        )
    }

}
TableDeudoresCentro.propTypes = {
    data: PropTypes.array,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
};

export default TableDeudoresCentro;


// WEBPACK FOOTER //
// ./src/components/panel-situacion-financiera/components/TableDeudoresCentro.js